import { useEffect, useState } from 'react'

export function useFadeInAnimation(timeout: number) {
    const [showFadeIn, setfadeInVisible] = useState(false)
    const [showBackground, setShowBackground] = useState(false)

    const handleStartAnimation = () => {
        setfadeInVisible(true)
        setShowBackground(true)
        setTimeout(() => {
            setfadeInVisible(false)
        }, timeout)
    }

    useEffect(() => {
        handleStartAnimation()
    }, [])

    return { showFadeIn, showBackground }
}
